<div class="increase-credit-limit-page card-table-layout">
    <lsq-banner
        [titleText]="title"
        [hasContent]="!isMobile"
        [reportName]="!isMobile && title"
        [analyticsName]="analyticsName"
        [hideExport]="true"
    >
    </lsq-banner>
    <div class="container-fluid page-container" *ngIf="dataSource">
        <!-- preload icons so they dont pop into existence -->
        <div [hidden]="true">
            <lsq-icon [type]="icons.CheckmarkCircle"></lsq-icon>
            <lsq-icon [type]="icons.XCircle"></lsq-icon>
            <lsq-icon [type]="icons.Clock"></lsq-icon>
        </div>
        <div class="row">
            <div class="col-xl-4" [ngClass]="{ 'mobile-card': isMobile }">
                <lsq-sticky-wrapper [stickyEnabled]="useStickyCard && !isStickyCardTallestItem">
                    <div class="card card-inverse increase-credit-form-card" #stickyCardRef>
                        <div class="card-header" i18n="Increase credit form header">
                            Select Customer & Increase Amount
                        </div>
                        <div class="card-body">
                            <div [hidden]="waitingOnIncreaseRequest">
                                <div *ngIf="increaseResponse" [@fadeIn]>
                                    <div
                                        *ngIf="
                                            increaseResponse.creditRequestStatus ===
                                            increaseCreditLimitStatus.Approved
                                        "
                                    >
                                        <span class="status-icon">
                                            <lsq-icon [type]="icons.CheckmarkCircle"></lsq-icon>
                                        </span>
                                        <h3 class="status-text">
                                            <span
                                                i18n="
                                                    Part 1/3: We've increased <CustomerName> credit
                                                    limit to <DollarAmount>.
                                                "
                                            >
                                                We’ve increased
                                            </span>
                                            {{ lastIncreaseCustomerName }}
                                            <span
                                                i18n="
                                                    Part 2/3: We've increased <CustomerName> credit
                                                    limit to <DollarAmount>.
                                                "
                                            >
                                                credit limit to
                                            </span>
                                            {{ increaseResponse.approvedAmount | currency }}
                                            <span
                                                i18n="
                                                    Part 3/3: We've increased <CustomerName> credit
                                                    limit to <DollarAmount>.
                                                "
                                                >.</span
                                            >
                                        </h3>
                                    </div>
                                    <div
                                        *ngIf="
                                            increaseResponse.creditRequestStatus ===
                                            increaseCreditLimitStatus.Denied
                                        "
                                    >
                                        <span class="status-icon">
                                            <lsq-icon [type]="icons.XCircle"></lsq-icon>
                                        </span>
                                        <h3 class="status-text">
                                            <span
                                                i18n="
                                                    Part 1/2: At this time, we are unable to
                                                    increase the credit limit for <CustomerName>.
                                                "
                                            >
                                                At this time, we are unable to increase the credit
                                                limit for
                                            </span>
                                            {{ lastIncreaseCustomerName }}
                                            <span
                                                i18n="
                                                    Part 2/2: At this time, we are unable to
                                                    increase the credit limit for <CustomerName>.
                                                "
                                                >.</span
                                            >
                                        </h3>
                                    </div>
                                    <div
                                        *ngIf="
                                            increaseResponse.creditRequestStatus ===
                                                increaseCreditLimitStatus.Pending ||
                                            increaseResponse.creditRequestStatus ===
                                                increaseCreditLimitStatus.HasExisting
                                        "
                                    >
                                        <span class="status-icon">
                                            <lsq-icon [type]="icons.Clock"></lsq-icon>
                                        </span>
                                        <h3 class="status-text">
                                            <span
                                                i18n="
                                                    Part 1/2: Your credit increase request for
                                                    <CustomerName> is currently under review. We’ll
                                                    get back to you within 1 - 3 business days
                                                "
                                            >
                                                Your credit increase request for
                                            </span>
                                            {{ lastIncreaseCustomerName }}
                                            <span
                                                i18n="
                                                    Part 2/2: Your credit increase request for
                                                    <CustomerName> is currently under review. We’ll
                                                    get back to you within 1 - 3 business days
                                                "
                                            >
                                                is currently under review. We’ll get back to you
                                                within 1 - 3 business days.
                                            </span>
                                        </h3>
                                    </div>
                                    <p
                                        class="status-query"
                                        i18n="Increase credit limit form footer"
                                    >
                                        Would you like to increase the credit limit for another
                                        customer?
                                    </p>
                                </div>
                                <form [formGroup]="formGroup">
                                    <div class="row">
                                        <div class="col">
                                            <lsq-search
                                                #customerSearch
                                                name="customerSearch"
                                                placeholder="Search Customers"
                                                primaryKey="debtorKey"
                                                primaryDisplayKey="debtorName"
                                                secondaryDisplayKey="address"
                                                formControlName="customerSearchControl"
                                                [smallTextForResults]="true"
                                                (textChanged)="setShowAddNewCustomer(false)"
                                                (hasResults)="setShowAddNewCustomer(!$event)"
                                                [searchService]="getRelationshipsByClientService"
                                                [group]="formGroup"
                                            >
                                            </lsq-search>
                                            <a
                                                *ngIf="showAddNewCustomer"
                                                class="new-customer-button"
                                                [routerLink]="requestNewCustomerCreditLink"
                                                [queryParams]="{
                                                    name:
                                                        customerSearch?.input?.inputElement
                                                            ?.nativeElement?.value
                                                }"
                                            >
                                                <strong i18n="Add new customer button"
                                                    >Add New Customer</strong
                                                >
                                            </a>
                                        </div>
                                    </div>
                                    <div *ngIf="!increaseResponse">
                                        <div
                                            *ngIf="selectedCustomer"
                                            class="row increase-amount-row"
                                            [@fadeIn]
                                        >
                                            <div class="col">
                                                <lsq-currency-input
                                                    name="increaseCreditLimit"
                                                    label="Enter Total Requested Limit"
                                                    i18n-label="
                                                        Requested limit currency input label
                                                    "
                                                    formControlName="increaseCreditLimitControl"
                                                    [group]="formGroup"
                                                >
                                                </lsq-currency-input>

                                                <h4
                                                    *ngIf="
                                                        selectedCustomer &&
                                                        selectedCustomer.creditLimit
                                                    "
                                                    class="current-credit-limit"
                                                    [@fadeIn]
                                                >
                                                    <span
                                                        i18n="
                                                            Requested limit currency input sub-label
                                                        "
                                                    >
                                                        The current credit limit is
                                                    </span>
                                                    {{ selectedCustomer.creditLimit | currency }}
                                                </h4>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col">
                                                <lsq-button
                                                    size="block"
                                                    i18n="Submit request button"
                                                    buttonClass="submit-credit-request-btn"
                                                    (buttonClick)="increaseCreditLimit()"
                                                    [group]="formGroup"
                                                    [disabled]="!selectedCustomer"
                                                    type="submit"
                                                >
                                                    Submit Request
                                                </lsq-button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div
                                class="waiting-on-increase"
                                *ngIf="waitingOnIncreaseRequest"
                                [@fadeIn]
                            >
                                <lsq-circle-loader></lsq-circle-loader>
                                <h3 i18n="Submit request pending label">
                                    Please wait while we process your credit limit increase.
                                </h3>
                            </div>
                        </div>
                    </div>
                </lsq-sticky-wrapper>
            </div>
            <div class="col-xl-8" [ngClass]="{ 'mobile-list': isMobile }">
                <div class="card increase-credit-table-card" #tableRef>
                    <div
                        *ngIf="!selectedCustomer"
                        class="card-header"
                        i18n="Request history table header"
                    >
                        Credit Increase Request History
                    </div>
                    <div *ngIf="selectedCustomer" class="card-header">
                        {{ selectedCustomer.debtorName }}
                        <span i18n="Request history table header"
                            >Credit Increase Request History</span
                        >
                    </div>
                    <div
                        class="card-body"
                        [ngClass]="{ 'no-margins': !(responsiveService.smBelow | async) }"
                    >
                        <div class="row">
                            <div class="col">
                                <lsq-data-table-mobile
                                    [dataSource]="dataSource"
                                    [isPaginated]="false"
                                    *ngIf="responsiveService.smBelow | async"
                                >
                                    <ng-template #mobileCardHeader let-row="row">
                                        <div class="request-history-mobile-card-header">
                                            <div class="mtc-header-content-left">
                                                <div class="mtc-header-super-title">
                                                    {{ row?.debtorName }}
                                                </div>
                                                <div class="mtc-header-title">
                                                    {{ row.requestedAmount | lsqCurrency }}
                                                </div>
                                                <div class="mtc-header-sub-title">
                                                    {{
                                                        row.startDate
                                                            | date: dateFormat.LsqShortYear
                                                    }}
                                                </div>
                                            </div>

                                            <div class="mtc-header-content-right">
                                                <div class="mtc-header-status-text">
                                                    <span class="status-text">{{
                                                        enumDisplay.CreditRequestStatus[
                                                            row.creditRequestStatus
                                                        ]
                                                    }}</span>
                                                    <lsq-icon
                                                        [type]="icons.Circle"
                                                        [color]="
                                                            statusColor[
                                                                creditRequestStatus[
                                                                    row.creditRequestStatus
                                                                ]
                                                            ]
                                                        "
                                                    ></lsq-icon>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-template>

                                    <ng-template #mobileCardColumns let-row="row">
                                        <div class="card-item" *ngIf="showCustomerColumn$ | async">
                                            <div class="card-item-label">Customer</div>
                                            <div class="card-item-value">
                                                <a
                                                    [routerLink]="getCustomerRoute(row.debtorKey)"
                                                    [ngStyle]="{
                                                        textTransform: 'none',
                                                        'font-size': '1.3rem'
                                                    }"
                                                >
                                                    {{ row.debtorName }}
                                                </a>
                                            </div>
                                        </div>

                                        <div class="card-item">
                                            <div class="card-item-label">
                                                {{ requestedAmountMobileHeader }}
                                            </div>
                                            <div class="card-item-value">
                                                {{ row.requestedAmount | lsqCurrency }}
                                            </div>
                                        </div>

                                        <div class="card-item">
                                            <div class="card-item-label">
                                                {{ approvedAmountMobileHeader }}
                                            </div>
                                            <div class="card-item-value">
                                                {{ row.approvedAmount | lsqCurrency }}
                                            </div>
                                        </div>

                                        <div class="card-item">
                                            <div class="card-item-label">{{ reasonHeader }}</div>
                                            <div class="card-item-value">
                                                {{ row.reason }}
                                            </div>
                                        </div>
                                    </ng-template>
                                </lsq-data-table-mobile>

                                <lsq-data-table
                                    *ngIf="!(responsiveService.smBelow | async)"
                                    [dataSource]="dataSource"
                                    [isPaginated]="false"
                                    [columnVisibilities]="{
                                        debtorName: showCustomerColumn$ | async
                                    }"
                                >
                                    <lsq-row-count-column></lsq-row-count-column>

                                    <lsq-date-column
                                        [column]="{
                                            key: 'startDate',
                                            header: dateHeader,
                                            width: '6.5rem'
                                        }"
                                    >
                                    </lsq-date-column>

                                    <lsq-column
                                        [column]="{
                                            key: 'debtorName',
                                            header: debtorNameHeader
                                        }"
                                    >
                                        <ng-template [custom-cell] let-row="row">
                                            <a
                                                [routerLink]="getCustomerRoute(row.debtorKey)"
                                                class="text-truncate"
                                                [ngStyle]="{ textTransform: 'none' }"
                                            >
                                                <lsq-truncate
                                                    [value]="row.debtorName"
                                                    [maxLength]="25"
                                                ></lsq-truncate>
                                            </a>
                                        </ng-template>
                                    </lsq-column>

                                    <lsq-currency-column
                                        [column]="{
                                            key: 'requestedAmount',
                                            header: requestedAmountHeader
                                        }"
                                    >
                                    </lsq-currency-column>

                                    <lsq-currency-column
                                        [column]="{
                                            key: 'approvedAmount',
                                            header: approvedAmountHeader
                                        }"
                                    >
                                    </lsq-currency-column>

                                    <lsq-column
                                        [column]="{
                                            key: 'creditRequestStatusDot',
                                            width: '2rem',
                                            sortable: false
                                        }"
                                    >
                                        <ng-template [custom-cell] let-row="row">
                                            <span
                                                *ngIf="
                                                    row.creditRequestStatus !== null &&
                                                    statusColor[
                                                        creditRequestStatus[row.creditRequestStatus]
                                                    ]
                                                "
                                                [ngStyle]="{
                                                    float: 'right',
                                                    paddingRight: '0.75rem'
                                                }"
                                            >
                                                <lsq-icon
                                                    [type]="icons.Circle"
                                                    [color]="
                                                        statusColor[
                                                            creditRequestStatus[
                                                                row.creditRequestStatus
                                                            ]
                                                        ]
                                                    "
                                                ></lsq-icon>
                                            </span>
                                        </ng-template>
                                    </lsq-column>

                                    <lsq-column
                                        [column]="{
                                            key: 'creditRequestStatus',
                                            header: statusHeader,
                                            width: '9rem'
                                        }"
                                    >
                                        <ng-template [custom-cell] let-row="row">
                                            {{
                                                enumDisplay.CreditRequestStatus[
                                                    row.creditRequestStatus
                                                ]
                                            }}
                                        </ng-template>
                                    </lsq-column>

                                    <lsq-column
                                        [column]="{
                                            key: 'reason',
                                            header: reasonHeader
                                        }"
                                    >
                                        <ng-template [custom-cell] let-row="row">
                                            {{ row.reason }}
                                        </ng-template>
                                    </lsq-column>
                                </lsq-data-table>

                                <div *ngIf="moreHistoryResults" class="see-more">
                                    <a [routerLink]="creditRequestHistoryReportLink">
                                        <strong i18n="Table footer link to report page">
                                            Full Credit Increase Request History Report
                                        </strong>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
